import { config } from '../config';
import { AnalyticsClass } from '@kilornd/analytics-wrapper/dist';

export const Analytics = new AnalyticsClass('production', config.GTM_TAG);
